import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {Breadcrumb, Grid,} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import TableStockBranch from "../../components/charts/TableStockBranch";

class CurrentStock extends Component {

    componentDidMount() {
        this.refs.stock_branch_office.loadData('');
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Quipuu - Inventario</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/sale'>Vender</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Inventario</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Grid stackable>
                    <Grid stackable textAlign='center'>
                        <Grid.Row columns={1}>
                            <Grid.Column>
                                <TableStockBranch
                                    title='Inventario'
                                    id='stock_branch_office'
                                    ref='stock_branch_office'
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withRouter(CurrentStock);



// WEBPACK FOOTER //
// ./src/containers/sale/CurrentStock.js